import { render, staticRenderFns } from "./contract-details.vue?vue&type=template&id=167b62c1"
import script from "./contract-details.vue?vue&type=script&lang=js"
export * from "./contract-details.vue?vue&type=script&lang=js"
import style0 from "./contract-details.vue?vue&type=style&index=0&id=167b62c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports